import React, { useState } from "react";
import { Modal, DatePicker, Select, Form, Input} from "antd";
function ApplyModal() {
    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = () => setIsModalVisible(true);

    const handleCancel = () => setIsModalVisible(false);
    const { Option } = Select;
    const dateFormat = "DD-MM-YYYY";
    return (
        <div className="modalBox">
            <button className="bookingBtn" onClick={showModal}>Ứng tuyển ngay</button>
            <Modal
                title="Thông tin ứng tuyển"
                className="modalStyle"
                visible={isModalVisible}
                onCancel={handleCancel}
                footer={null}
            >
                <Form>
                    <p>Hãy tham gia cùng chúng tôi</p>
                    <div className="row">
                        <div className="col-lg-6 col-12">
                            <Form.Item className="formInput"
                                label="Họ và tên"
                                name="email"
                            >
                                <Input
                                    type="text"
                                    placeholder="Nhập họ tên đầy đủ"
                                />
                            </Form.Item>
                            
                        </div>
                        <div className="col-lg-6 col-12">
                            <Form.Item className="formInput"
                                label="Email"
                                name="email"
                            >
                                <Input
                                    type="text"
                                    placeholder="Nhập email của bạn"
                                />
                            </Form.Item>
                        </div>
                        <div className="col-lg-6 col-12">
                            <Form.Item className="formInput"
                                label="Số điện thoại"
                                name="phoneNumber"
                            >
                                <Input
                                    type="text"
                                    placeholder="Nhập số điện thoại của bạn"
                                />
                            </Form.Item>
                        </div>
                        <div className="col-lg-6 col-12">
                            <Form.Item className="formInput formSelect"
                                label="Vị trí ứng tuyển"
                                name="email"
                            >
                                <Select placeholder="vị trí ứng tuyển">
                                    <Option>Nhân viên bếp</Option>
                                    <Option>Nhân viên phòng</Option>
                                    <Option>Nhân viên Buồng phòng</Option>
                                    <Option>Nhân viên kỹ thuật an ninh</Option>
                                    <Option>chuyên viên kinh doanh</Option>
                                </Select>
                            </Form.Item>
                        </div>
                        <div className="col-lg-6 col-12">
                            <Form.Item className="formInput formSelect"
                                label="Ngày sinh"
                                name="birthDate"
                            >
                                <DatePicker
                                    name="birthDate"
                                    placeholder="Ngày sinh"
                                    format={dateFormat}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-12">
                            <Form.Item className="formInput"
                                label="Cv của bạn "
                                name="cv"
                            >
                                <Input type="file" name="" id="" />
                            </Form.Item>
                        </div>
                    </div>
                </Form>
                
                <Form.Item className="btnModal">
                    <button className="btnStyle" >
                        Ứng tuyển
                    </button>
                </Form.Item>

            </Modal>
        </div>
    );
}
export default ApplyModal;
